<template>
  <el-row :gutter="5" type="flex" justify="start" class="tg-list-card--group">
    <template v-for="(list, i) in lists">
      <tg-list-card
        :key="i"
        :title="list.label"
        :agent_name="list.agent_name"
        :data="list.data"
        @on-click="handleListClick"
        :disabled="disabled"
      ></tg-list-card>
    </template>
  </el-row>
</template>

<script>
import TgListCard from "@/components/card/TgListCard";
import formatter from "@/utils/formatter";

export default {
  components: {
    TgListCard,
  },
  props: {
    lists: Array,
    disabled: Boolean,
  },
  methods: {
    handleListClick(item) {
      //觸發item這個元件的【on-click】方法
      this.$emit("on-click", item);
    },
    format(value, format) {
      if (!format) {
        return value;
      }
      return formatter.format(value, format);
    },
  }
};
</script>
